import req from "../../../services/psikotest/request";

class Assessor {
  async list() {
    try {
      const res = await req.get("/api/psikotest_system/assessor/");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async get(id: string) {
    try {
      const res = await req.get("/api/psikotest_system/assessor/" + id);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async create(assessor: TPSAssessorCreateUpdate) {
    try {
      const res = await req.post("/api/psikotest_system/assessor/", assessor);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update(id: string, assessor: TPSAssessorCreateUpdate) {
    try {
      const res = await req.put("/api/psikotest_system/assessor/" + id, assessor);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async delete(userId: string) {
    try {
      const res = await req.delete("/api/psikotest_system/assessor/" + userId);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default Assessor;
